import React from 'react';
import { Link } from 'react-router-dom';
import MissingValue from './MissingValue';
import { highlightText } from '../Highlight';
import { MONO_FONT } from './ItemCell';

export interface VendorCellProps {
  name?: string | null;
  /** Short code from the part-number app, shown as a mono tag. */
  appCode?: string | null;
  linkTo?: string;
  missingLabel?: string;
  /** Search text: matching parts of the name and code are wrapped in <mark>. */
  highlight?: string | null;
}

const VendorCell: React.FC<VendorCellProps> = ({ name, appCode, linkTo, missingLabel, highlight }) => {
  if (!name) return <MissingValue label={missingLabel ?? 'no vendor'} />;

  const shown = highlight ? highlightText(name, highlight) : name;
  const label = linkTo ? <Link to={linkTo}>{shown}</Link> : <span>{shown}</span>;

  return (
    <span style={{ whiteSpace: 'nowrap' }}>
      {label}
      {appCode && (
        <span
          style={{
            marginLeft: 6,
            font: `600 11px ${MONO_FONT}`,
            color: 'rgba(0,0,0,0.62)',
            background: '#f8f9fb',
            border: '1px solid #e3e6ec',
            borderRadius: 4,
            padding: '0 5px',
          }}
        >
          {highlight ? highlightText(appCode, highlight) : appCode}
        </span>
      )}
    </span>
  );
};

export default VendorCell;
